import React from 'react';
import { PELOTON_PLATFORM } from '@webtv/env';
import { captureException } from '@webtv/error-reporting-v2';
import { Feature, isFeatureEnabled } from '@webtv/feature-toggles';
export var getIsTVOnline = function getIsTVOnline() {
  if (PELOTON_PLATFORM === 'samsung' && typeof webapis !== 'undefined') {
    return webapis.network.getActiveConnectionType() !== 0;
  }

  if (PELOTON_PLATFORM === 'lg' && typeof window !== 'undefined') {
    return window.navigator.onLine;
  }

  return true;
};

var webApisNetworkListener = function webApisNetworkListener(value, offlineAction, onlineAction) {
  if (value == webapis.network.NetworkState.GATEWAY_DISCONNECTED) {
    offlineAction();
  } else if (value == webapis.network.NetworkState.GATEWAY_CONNECTED) {
    onlineAction();
  }
};

export var useOfflineError = function useOfflineError(offlineAction, onlineAction) {
  var offlineErrorModalEnabled = isFeatureEnabled(Feature.OfflineErrorModal);
  React.useEffect(function () {
    if (offlineErrorModalEnabled) {
      if (PELOTON_PLATFORM === 'samsung' && typeof webapis !== 'undefined') {
        var listenerId = webapis.network.addNetworkStateChangeListener(function (value) {
          return webApisNetworkListener(value, offlineAction, onlineAction);
        });
        return function () {
          try {
            webapis.network.removeNetworkStateChangeListener(listenerId);
          } catch (e) {
            // report errors to sentry, but no need to throw an error on the page
            captureException(e);
          }
        };
      } else if (PELOTON_PLATFORM === 'lg') {
        window.addEventListener('offline', offlineAction);
        window.addEventListener('online', onlineAction);
        return function () {
          window.removeEventListener('offline', offlineAction);
          window.removeEventListener('online', onlineAction);
        };
      }
    }

    return function () {
      return null;
    };
  }, [offlineAction, onlineAction, offlineErrorModalEnabled]);
};